module.exports = __webpack_public_path__ + "static/media/chart-if-you-invest-v2.900fff0a.svg";